import {ElNotification} from "element-plus";

let notificationIns = undefined
const notification = (options) => {
	if (notificationIns) {
		notificationIns.close()
	}
	notificationIns = ElNotification(options)
}
['error', 'success', 'info', 'warning'].forEach(i => {
	notification[i] = (options) => {
		const opt = typeof options === 'string' ? {
			message: options
		} : options
		notification(Object.assign({}, opt, {type: i}))
	}
})

export {notification,ElNotification}
